import FooterModel from './FooterModel';

export default class Globals {
	footer: FooterModel;
	constructor(data: object) {
		Object.assign(this, data);
	}
}
